import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, G, Defs, Rect, ClipPath } from "react-native-svg";

import AppTheme from "../../AppTheme";

export default function TrackIcon({ onPress }) {
  return (
    <TouchableOpacity onPress={onPress}>
      <Svg
        width="55"
        height="36"
        viewBox="10 0 55 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#filter_track_icon)">
          <Path
            d="M40.2479 11.059V10.9607C40.2475 10.8299 40.2818 10.7013 40.3475 10.5881C40.4131 10.475 40.5077 10.3813 40.6215 10.3168C42.4648 9.30914 43.1332 6.87604 43.3741 5.14092C43.4079 4.90351 43.3903 4.66162 43.3225 4.43159C43.2548 4.20155 43.1385 3.98872 42.9815 3.80748C42.8245 3.62624 42.6304 3.48079 42.4124 3.38097C42.1943 3.28115 41.9574 3.22928 41.7176 3.22885H34.9099C34.6703 3.22857 34.4335 3.27979 34.2154 3.37906C33.9974 3.47832 33.8032 3.6233 33.6461 3.80418C33.489 3.98505 33.3727 4.19758 33.3049 4.42737C33.2371 4.65716 33.2196 4.89883 33.2534 5.13601C33.4746 6.84655 34.1382 9.24524 35.9323 10.2775C36.0668 10.354 36.1786 10.4648 36.2563 10.5987C36.3341 10.7325 36.3749 10.8846 36.3746 11.0393V11.0393C36.3746 11.2167 36.3267 11.3907 36.2358 11.543C36.145 11.6953 36.0146 11.8202 35.8585 11.9044C34.1038 12.8973 33.4746 15.2223 33.2436 16.8935C33.2135 17.129 33.234 17.3682 33.3038 17.5951C33.3737 17.822 33.4912 18.0313 33.6485 18.2091C33.8058 18.3869 33.9993 18.529 34.216 18.6259C34.4327 18.7229 34.6676 18.7724 34.905 18.7712H41.7127C41.954 18.7705 42.1923 18.7177 42.4113 18.6164C42.6304 18.5151 42.8249 18.3677 42.9817 18.1843C43.1385 18.0009 43.2539 17.7857 43.3199 17.5536C43.3859 17.3215 43.4011 17.0779 43.3643 16.8394C43.1234 15.1928 42.4795 12.9072 40.7444 11.9241C40.592 11.8373 40.4656 11.7113 40.3783 11.5592C40.291 11.4071 40.246 11.2344 40.2479 11.059Z"
            stroke={AppTheme.FOOTER_COLOR}
            strokeWidth="1.96614"
            strokeMiterlimit="10"
          />
        </G>
        <Defs>
          <ClipPath id="filter_track_icon">
            <Rect
              width="12.6177"
              height="18"
              fill="white"
              transform="translate(32 2)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
